import { Box, Typography, Button, Divider, List, ListItem } from "@mui/joy";
import { useEffect, useState } from "react";
import { IRegisterRequest, IRegistrationFormData } from "../../utils/types";
import { TextInput } from "../../utils/input";
import { toast } from "react-toastify";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useRegisterUserMutation, useSendOtpMutation, useVerifyOTPMutation, useGetVerifyVendorMutation } from "../../services/auth/authApiSlice";
import Loading from "../../components/Common/Loading";
import { useNavigate } from "react-router-dom";
import ForgotPasswordDetailsCard from "../forgot-password/ForgotPasswordDetailsCard";

const RegisterPage = () => {
  const navigate = useNavigate();
  const [selectedVendor, setSelectedVendor] = useState(null);


  const baseRegistrationData: IRegistrationFormData = {
    phone: "",
    otp: "",
    password: "",
    repassword: "",
    name: "",
  };

  const [showPasswordValidation, setShowPasswordValidation] = useState<boolean>(false);
  const [isOtpSent, setIsOtpSent] = useState<boolean>(false);
  const [isOtpVerified, setIsOtpVerified] = useState<boolean>(false);
  const [registrationData, setRegistrationData] = useState<IRegistrationFormData>(baseRegistrationData);
  const [verifyData, setVerifyData] = useState<any>(null);

  const [registerUser, { isLoading }] = useRegisterUserMutation();
  const [sendOtp, { isLoading: sendOtpLoading }] = useSendOtpMutation();
  const [verifyOTP, { isLoading: verifyOtpLoading }] = useVerifyOTPMutation();

  const [vendorNotFound, setVenderNotFound] = useState<any>(false);

  const [getVerifyVendor, { isLoading: isLoadingVenderChecking }] = useGetVerifyVendorMutation();

  const handleInputPhone = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (/^\d*$/.test(value) && value.length < 11) {
      setRegistrationData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if ('otp' === name && value.length > 6) {
      return;
    }
    setRegistrationData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "password") {
      setShowPasswordValidation(value.length > 0);
    }
    if (name === "vendorCode") {
      // setIsOtpSent(true);
      setVenderNotFound(false);
    }
  };

  const handleSendOtp = async () => {
    try {
      const response = await sendOtp({ mobile: registrationData?.phone, type: 'new' }).unwrap();

      if (response?.success) {
        toast.success(response?.message);
        setIsOtpSent(true);
      } else {
        toast.error(`Error Sending OTP: ${response?.message}`);
      }
      // Call OTP send API here
    } catch (err) {
      toast.error(`Error Sending OTP: ${err?.data?.message || err?.message}`);
    }
  };


  const handleVerifyOtp = async () => {
    try {
      const response = await verifyOTP({ otp: registrationData?.otp, phone_number: registrationData.phone }).unwrap();
      if (response?.success) {

        toast.success(response?.message);
        setVerifyData([...response?.vendor_data]);
        // setVerifyData([{ ...response?.vendor_data }]);
        setRegistrationData((prev) => ({
          ...prev,
          name: response?.vendor_data[0]?.name
        }));
        if (response?.vendor_data?.name === '') {
          toast.error("Kindly update the vendor name associated with your vendor code.")
        } else {
          setIsOtpVerified(true);
        }
      } else {
        toast.error(`Error Verifying OTP: ${response?.message}`);
      }
    } catch (err) {
      toast.error(`Error Verifying OTP: ${err?.data?.message || err?.message}`);
    }
  };

  const validatePassword = (password: string) => {
    return {
      minLength: password.length >= 8,
      hasUppercase: /[A-Z]/.test(password),
      hasLowercase: /[a-z]/.test(password),
      hasNumber: /\d/.test(password),
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    };
  };

  const handleResgisterClick = async () => {
    try {
      const payload: IRegisterRequest = {
        vendor_code: selectedVendor[0]?.value,
        phone: registrationData?.phone,
        password: registrationData?.password,
        name: registrationData?.name,
      };
      const result = await registerUser(payload).unwrap();
      if (result?.success) {
        toast.success(result?.message);
        navigate("/login", { replace: true });
      } else {
        toast.error(result?.message);
      }
    } catch (err) {
      toast.error(err?.data?.message || err?.message);
    }
  };

  const otpFormControlSx = {
    width: "100%",
    ...(isOtpVerified && {
      "& .MuiInput-root": {
        backgroundColor: "#e8f5e8",
        borderColor: "#4caf50",
      },
      "& .MuiInput-root:focus-within": {
        borderColor: "#4caf50",
      },
    }),
  };
  const formControlSx = { width: "100%" };
  const isPhoneValid = /^\d{10}$/.test(registrationData.phone);
  const passwordValidation = validatePassword(registrationData.password);
  const isPasswordValid = Object.values(passwordValidation).every(Boolean);

  // const handleVerifyVendorId = async()=>{

  //   let vendor_id = "00" + registrationData.vendorCode.replace(/^0+/,'');
  //   try
  //   {
  //     const result = await getVerifyVendor(vendor_id).unwrap();
  //     setIsVerify(false);
  //     if(result?.message === "Vendor not Found"){
  //       setVenderNotFound(true);
  //       setRegistrationData((prev) => ({
  //         ...prev,
  //         phone: 'xxxxx',
  //         name: '',
  //       }));
  //     } else {
  //       const vendorData:any = result?.message;
  //       setVerifyData({...vendorData});
  //       setRegistrationData((prev) => ({
  //         ...prev,
  //         phone: vendorData.contactNumber,
  //         name: vendorData.name,
  //       }));
  //       setIsOtpSent(false);

  //     }
  //   }
  //   catch(err){

  //   }

  // }

  const ValidationItem = ({ isValid, text }: { isValid: boolean; text: string }) => (
    <ListItem sx={{ py: 0.5, px: 0 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {isValid ? <CheckIcon sx={{ color: "#4caf50", fontSize: 16 }} /> : <CloseIcon sx={{ color: "#f44336", fontSize: 16 }} />}
        <Typography level="body-sm" sx={{ color: isValid ? "#4caf50" : "#f44336" }}>
          {text}
        </Typography>
      </Box>
    </ListItem>
  );

  return isLoading ? (
    <Loading isLoading={isLoading} />
  ) : (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        py: 3,
        gap: 2,
        maxWidth: 500,
        margin: "auto",
      }}
      className="register-box"
    >
      <Typography level="h3" textAlign="center" className="heading-2">
        Register New User
      </Typography>

      {/* <TextInput
        name="vendorCode"
        label="Vendor Code"
        formControlSx={formControlSx}
        value={registrationData.vendorCode}
        onChange={handleInputChange}
        // readOnly={isOtpSent}
        required
        placeholder="Enter Vendor Code"
      /> */}

      <div className="vendor-error">
        {isLoadingVenderChecking && <Typography className="checkingText">Verifying...</Typography>}
        {vendorNotFound && <Typography style={{ color: "red" }}>This vendor id not found.</Typography>}
      </div>
      {registrationData?.name !== "" && (
        <div style={{ width: "100%" }}>
          <Typography>
            <b>Vendor Name:</b> {registrationData?.name}{" "}
          </Typography>
        </div>
      )}
      {/* { (isVerify && registrationData.vendorCode.length > 0) && <Button color="primary" variant="solid" onClick={handleVerifyVendorId} sx={{ alignSelf: "flex-end" }} className="heading-4">
          Verify
      </Button>} */}

      <TextInput
        className="phone_number"
        name="phone"
        label="Phone Number"
        formControlSx={formControlSx}
        value={registrationData.phone}
        onChange={handleInputPhone}
        required
        placeholder="Enter 10-digit Phone Number"
      />
      {isPhoneValid && !isOtpSent && (
        <Button color="primary" loading={sendOtpLoading} variant="solid" onClick={handleSendOtp} sx={{ alignSelf: "flex-end" }} className="heading-4">
          Send OTP
        </Button>
      )}

      {isOtpSent && (
        <>
          <Box sx={{ position: "relative", width: "100%" }}>
            <TextInput
              name="otp"
              label="OTP"
              formControlSx={otpFormControlSx}
              value={registrationData.otp}
              onChange={handleInputChange}
              required
              placeholder="Enter OTP"
              disabled={isOtpVerified}
            />
            {isOtpVerified && (
              <CheckCircleIcon
                sx={{
                  position: "absolute",
                  right: 12,
                  top: 42,
                  transform: "translateY(-50%)",
                  color: "#4caf50",
                  fontSize: 24,
                }}
              />
            )}
          </Box>
          {!isOtpVerified && (
            <Button
              color="primary"
              variant="outlined"
              loading={verifyOtpLoading}
              onClick={handleVerifyOtp}
              sx={{ alignSelf: "flex-end" }}
              disabled={registrationData?.otp?.length < 6}
            >
              Verify OTP
            </Button>
          )}
        </>
      )}

      {isOtpVerified &&
        (verifyData?.length > 0 ? <ForgotPasswordDetailsCard vendorList={verifyData} selectedVendor={selectedVendor} setSelectedVendor={setSelectedVendor} /> : <Typography style={{ color: "red" }}>No user found for this phone number.</Typography>)}

      <Divider sx={{ width: "100%" }} />

      <TextInput
        name="password"
        label="Password"
        formControlSx={formControlSx}
        value={registrationData.password}
        onChange={handleInputChange}
        required
        placeholder="Enter Password"
        type="password"
        readOnly={!isOtpVerified}
      />

      <TextInput
        name="repassword"
        label="Re-password"
        formControlSx={formControlSx}
        value={registrationData.repassword}
        onChange={handleInputChange}
        required
        placeholder="Enter Re-password"
        type="password"
        readOnly={!isOtpVerified}
      />

      {showPasswordValidation && (
        <Box sx={{ width: "100%", mt: 1 }}>
          <Typography level="body-sm" sx={{ mb: 1, fontWeight: "medium" }}>
            Password Requirements:
          </Typography>
          <List sx={{ py: 0 }}>
            <ValidationItem isValid={passwordValidation.minLength} text="At least 8 characters" />
            <ValidationItem isValid={passwordValidation.hasUppercase} text="At least one uppercase letter" />
            <ValidationItem isValid={passwordValidation.hasLowercase} text="At least one lowercase letter" />
            <ValidationItem isValid={passwordValidation.hasNumber} text="At least one number" />
            <ValidationItem isValid={passwordValidation.hasSpecialChar} text="At least one special character (!@#$%^&*)" />
            <ValidationItem isValid={registrationData.repassword === registrationData.password} text="Password and Re-pasword match" />
          </List>
        </Box>
      )}


      <Button
        className="heading-4"
        color="success"
        variant="solid"
        sx={{ mt: 2, width: "100%" }}
        onClick={handleResgisterClick}
        disabled={!isOtpVerified || !isPasswordValid || registrationData.repassword !== registrationData.password || selectedVendor === null}
      >
        Register
      </Button>
    </Box>
  );
};

export default RegisterPage;
